var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card border-secondary" }, [
    _c("div", { staticClass: "card-header" }, [
      _vm._v("\n        " + _vm._s(_vm.typename?.name) + "\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _vm.showFieldId
          ? _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        id: `input-${_vm.parendId}-typename-${_vm.idx}-id`,
                        name: `${_vm.parendId}-typename-${_vm.idx}-id`,
                        placeholder: _vm.$t(
                          `${_vm.helpTranslateID}.id.placeholder`
                        ),
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              `${_vm.parendId}-typename-${_vm.idx}-id`,
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError(
                          `${_vm.parendId}-typename-${_vm.idx}-id`,
                          _vm.vScope
                        ),
                      },
                      model: {
                        value: _vm.typename.property_id,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.typename,
                            "property_id",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "typename.property_id",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.id`)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showFieldName
          ? _c("div", { staticClass: "col-sm" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "MaterialInput",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      staticClass: "city-form-group city-bg",
                      attrs: {
                        readonly: _vm.readonlyForm,
                        disabled: _vm.readonlyForm,
                        id: `input-${_vm.parendId}-typename-${_vm.idx}-name`,
                        name: `${_vm.parendId}-typename-${_vm.idx}-name`,
                        placeholder: _vm.$t(
                          `${_vm.helpTranslateID}.name.placeholder`
                        ),
                        "data-vv-scope": _vm.vScope,
                        inputClasses: [
                          {
                            "is-invalid": _vm.fnHasError(
                              `${_vm.parendId}-typename-${_vm.idx}-name`,
                              _vm.vScope
                            ),
                          },
                        ],
                        error: _vm.fnFirstError(
                          `${_vm.parendId}-typename-${_vm.idx}-name`,
                          _vm.vScope
                        ),
                      },
                      model: {
                        value: _vm.typename.property_name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.typename,
                            "property_name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "typename.property_name",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t(`${_vm.modelTranslateID}.name`)) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: `input-${_vm.parendId}-typename-${_vm.idx}-title`,
                    name: `${_vm.parendId}-typename-${_vm.idx}-title`,
                    placeholder: _vm.$t(
                      `${_vm.helpTranslateID}.title.placeholder`,
                      { typename: _vm.typename?.typename }
                    ),
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          `${_vm.parendId}-typename-${_vm.idx}-title`,
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError(
                      `${_vm.parendId}-typename-${_vm.idx}-title`,
                      _vm.vScope
                    ),
                  },
                  model: {
                    value: _vm.typename.property_title,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.typename,
                        "property_title",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "typename.property_title",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.title`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-auto d-flex align-items-center form-group" },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-info btn-sm min-w-auto my-0 mx-auto d-block",
                attrs: { type: "button" },
                on: { click: _vm.onResetProperties },
              },
              [_c("i", { staticClass: "fas fa-repeat" })]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("HelpSpan", {
              attrs: { helpText: `${_vm.helpTranslateID}.fields` },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm" }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }),
            _vm._v(" "),
            _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.properties.name`))),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-center", attrs: { scope: "col" } }, [
              _vm._v(_vm._s(_vm.$t(`${_vm.modelTranslateID}.properties.type`))),
            ]),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "text-center w-100px", attrs: { scope: "col" } },
              [
                _vm._v(
                  _vm._s(_vm.$t(`${_vm.modelTranslateID}.properties.order`))
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.readonlyForm
              ? _c("th", { attrs: { scope: "col" } })
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.typename.properties ?? [], function (property, pIdx) {
            return _c("tr", { key: `typename-${_vm.idx}-property-${pIdx}` }, [
              _c("td", [
                _vm._v(
                  "\n                        " +
                    _vm._s(property.source_name) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("SimpleInput", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "city-form-group city-bg city-bg-sm",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: `input-${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-name`,
                      name: `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-name`,
                      required: true,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-name`,
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError(
                        `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-name`,
                        _vm.vScope
                      ),
                    },
                    model: {
                      value: _vm.typename.properties[pIdx].name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.typename.properties[pIdx],
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "typename.properties[pIdx].name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("SimpleSelect", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "city-form-group city-bg city-bg-sm",
                    attrs: {
                      disabled: _vm.readonlyForm,
                      id: `input-${_vm.parendId}-typename-${_vm.idx}-property-type`,
                      name: `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-type`,
                      label: "name",
                      options: _vm.propertyTypes,
                      reduce: (option) => option.id,
                      required: true,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-type`,
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError(
                        `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-type`,
                        _vm.vScope
                      ),
                    },
                    model: {
                      value: _vm.typename.properties[pIdx].type,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.typename.properties[pIdx],
                          "type",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "typename.properties[pIdx].type",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("SimpleInput", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|integer",
                        expression: "'required|integer'",
                      },
                    ],
                    staticClass: "city-form-group city-bg city-bg-sm",
                    attrs: {
                      readonly: _vm.readonlyForm,
                      disabled: _vm.readonlyForm,
                      id: `input-${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-order`,
                      name: `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-order`,
                      type: "number",
                      required: true,
                      "data-vv-scope": _vm.vScope,
                      inputClasses: [
                        {
                          "is-invalid": _vm.fnHasError(
                            `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-order`,
                            _vm.vScope
                          ),
                        },
                      ],
                      error: _vm.fnFirstError(
                        `${_vm.parendId}-typename-${_vm.idx}-property-${pIdx}-order`,
                        _vm.vScope
                      ),
                    },
                    model: {
                      value: _vm.typename.properties[pIdx].order,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.typename.properties[pIdx],
                          "order",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "typename.properties[pIdx].order",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.readonlyForm
                ? _c(
                    "td",
                    { staticClass: "col-sm-auto text-center d-print-none" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-danger btn-sm min-w-auto my-0 mx-auto d-block",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.onRemoveProperty(pIdx)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-trash" })]
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }